import { MutationParams } from "@/types/network";
import { EndpointBuilder, BaseQueryFn } from "@reduxjs/toolkit/query";
import {
  BulkReadEntry,
  BulkReadInput,
  BulkReadMutationParams,
  BulkReadResponse,
} from "@features/feed/types";

export const createBulkReadMutation = <T>(
  builder: EndpointBuilder<BaseQueryFn, string, "api">,
  pathResolver: (params?: MutationParams<BulkReadInput>["params"]) => string,
) =>
  builder.mutation<BulkReadEntry<T>[] | undefined, BulkReadMutationParams>({
    query: ({ params, body }) => ({
      url: pathResolver(params),
      method: "POST",
      body,
    }),
    transformResponse: (response: BulkReadResponse<T>) => response.data,
  });
